import React, { Component } from 'react';

export default class Resume extends Component {
  render() {
    let resumeData = this.props.resumeData;
    const skillIcons = {
      ReactJS: 'devicon-react-original colored',
      ReactTS: 'devicon-typescript-plain colored',
      ReactNative: 'devicon-react-original colored',
      NodeJS: 'devicon-nodejs-plain colored',
      MongoDB: 'devicon-mongodb-plain colored',
      MySQL: 'devicon-mysql-plain colored',
      PostgreSQL: 'devicon-postgresql-plain colored',
      CSS: 'devicon-css3-plain colored',
      AWS: 'devicon-amazonwebservices-original colored',
      Docker: 'devicon-docker-plain colored',
      HTML5: 'devicon-html5-plain colored',
      Javascript: 'devicon-javascript-plain colored',
      Java: 'devicon-java-plain colored',
      PHP: 'devicon-php-plain colored',
      C: 'devicon-c-plain colored',
      'Unity Engine': 'devicon-unity-original colored',
      'Adobe Softwares': 'devicon-photoshop-plain colored',
      Angular: 'devicon-angularjs-plain colored',
      Electron: 'devicon-electron-original colored',
      'C#': 'devicon-csharp-plain colored',
      Blender: 'devicon-blender-original colored',
      Git: 'devicon-git-plain colored',
      'Network Debugging': 'devicon-cisco-plain colored',
      'Video Editing': 'devicon-premierepro-plain colored',
      'AI-assisted Development': 'devicon-github-original colored',
    };
    
    return (
      <section id="resume">
        {/* Education Section */}
        <div className="row education">
          <div className="three columns header-col">
            <h1><span>Education</span></h1>
          </div>
          <div className="nine columns main-col">
            {resumeData.education && resumeData.education.map((item, idx) => (
              <div key={idx} className="item">
                <h3>{item.UniversityName}</h3>
                <p className="info">
                  {item.specialization}
                  {item.gpa && <span> | GPA: {item.gpa}</span>}
                  <span>&bull;</span>
                  <em className="date">
                    {item.MonthOfPassing && `${item.MonthOfPassing} `}
                    {item.YearOfPassing}
                  </em>
                </p>
                <p>{item.Achievements}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Work Section */}
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Work Experience</span></h1>
          </div>
          <div className="nine columns main-col">
            {resumeData.work && resumeData.work.map((item, idx) => (
              <div key={idx} className="item">
                <h3>{item.CompanyName}</h3>
                <p className="info">
                  {item.specialization}
                  <span>&bull;</span>
                  <em className="date">
                    {item.MonthOfLeaving && `${item.MonthOfLeaving} `}
                    {item.YearOfLeaving}
                  </em>
                </p>
                <p>{item.Achievements}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Certificates Section */}
        <div className="row education">
          <div className="three columns header-col">
            <h1><span>Certificates</span></h1>
          </div>
          <div className="nine columns main-col">
            {resumeData.certificates && resumeData.certificates.map((item, idx) => (
              <div key={idx} className="item">
                <h3>{item.UniversityName}</h3>
                <p className="info">
                  {item.specialization}
                  <span>&bull;</span>
                  <em className="date">
                    {item.MonthOfPassing && `${item.MonthOfPassing} `}
                    {item.YearOfPassing}
                  </em>
                </p>
                {item.Achievements && <p>{item.Achievements}</p>}
              </div>
            ))}
          </div>
        </div>

        {/* Skills Section */}
        <div className="row skill">
          <div className="three columns header-col">
            <h1><span>Skills</span></h1>
          </div>
          <div className="nine columns main-col">
            {resumeData.skillsDescription && <p>{resumeData.skillsDescription}</p>}
            {(() => {
              const sortedSkills = (resumeData.skills || []).slice().sort((a, b) => b.proficiency - a.proficiency);
              return (
                <div className="skill-grid">
                  {sortedSkills.map((item, idx) => (
                    <div key={idx} className="skill-card">
                      <div className="skill-orb" style={{ '--fill-level': item.proficiency }}>
                        <div className="skill-liquid"></div>
                        {skillIcons[item.skillname] && (
                          <i className={`skill-icon-center ${skillIcons[item.skillname]}`}></i>
                        )}
                      </div>
                      <span className="skill-label">{item.skillname}</span>
                    </div>
                  ))}
                </div>
              );
            })()}
          </div>
        </div>
      </section>
    );
  }
}